module.exports = __webpack_public_path__ + "img/sidebar-order.562d591.svg";